(ns ncr.widgets.zip
  (:require [clojure.set :as set]
            [cljs.core.async :as async :refer-macros [go] :refer [<!]]
            [ncr.etc.pf :as pf]
            [ncr.etc.modal :as m]
            [ncr.etc.util :as u]
            [ncr.etc.zip :as zip]
            [ncr.widgets.bulk-selection :as bs]
            [uix.core.alpha :as uix]))


(defn- dialog-form [{:keys [fragments selected all on-toggle]}]
  [pf/c-panel {:is-scrollable true}
   [pf/c-panel-header {:class :pf-u-p-0 :variant :light :sticky :top}
    [pf/c-toolbar
     [pf/c-toolbar-content
      [bs/c-dropdown
       {:label-fn (partial u/format "%d selected")
        :selected selected
        :all all
        :on-change #(on-toggle all %)}]]]]
   [pf/c-panel-main {:max-height "600px"}
    [pf/c-panel-main-body
     [pf/c-data-list
      {:is-compact true
       :class-name :ncr-c-bulk-selection__fragment-attachments}
      (for [{:keys [id] :as fragment} fragments]
        [bs/c-fragment-attachments-list
         {:key id
          :fragment fragment
          :selected selected
          :on-change on-toggle}])]]]])

(defn- c-dialog-body [all-fragments]
  (let [fragments
        (uix/memo
          (fn []
            (->> all-fragments (filter (fn [{:keys [attachments]}] (seq attachments)))))
          [all-fragments])

        all-attachments
        (uix/memo
          (fn []
            (->> fragments (map #(map :id (:attachments %))) flatten set))
          [fragments])

        *selected-attachments (uix/state all-attachments)
        selected-attachments @*selected-attachments

        submit
        (uix/memo
          (fn []
            (when (seq selected-attachments)
              (fn [_]
                (m/close!
                  (->> fragments
                    (mapcat
                      (fn [{:keys [attachments] :as fragment}]
                        (->> attachments
                          (map
                            (fn [{:keys [id] :as attachment}]
                              (when (contains? selected-attachments id)
                                (assoc (select-keys attachment [:id :fileName])
                                  :fragment-id (:id fragment))))))))
                    (filter some?))))))
          [fragments selected-attachments])]
    [m/c-modal
     {:id :zip-dialog
      :title "Download as zip"
      :variant :large
      :actions
      [[pf/c-button
        {:variant :primary
         :is-disabled (nil? submit)
         :on-click submit}
        "Download"]
       [pf/c-button
        {:variant :link :on-click #(m/close! nil)} "Cancel"]]}
     (if (seq fragments)
       [dialog-form
        {:fragments fragments
         :selected selected-attachments
         :all all-attachments
         :on-toggle
         (fn [ids select?]
           (swap! *selected-attachments (if select? set/union set/difference) ids))}]
       [pf/c-empty-state {}
        "No Fragments with Downloadable Attachments"])]))

(defn !download [_me fragments]
  (go
    (if-let [selected (<! (m/!modal #'c-dialog-body fragments))]
      (<! (zip/download! {:attachments selected}))
      [:error :cancel])))
